import { GET_ACTIVE_ORDERS } from './constants';
import { Order } from './fetchAllHEOrder';
import fetchWithRefresh from './fetchWithRefresh';

interface Response {
    success: boolean;
    orders: Order[];
}

export default (
    docIds: string = '',
    active_from: number = 0,
    from: string = '',
    to: string = '',
): Promise<Response> => {
    return fetchWithRefresh(GET_ACTIVE_ORDERS(docIds, active_from, from, to)).then((res) =>
        res.json(),
    );
};
